<template>
  <div>
    <v-app-bar app color="primary" height="50" dark absolute clipped-left>
      <span class="auroraTitle">Lumora</span>
      <div>
        <span v-if="isLoadingMenu">
          <v-progress-circular
            indeterminate
            :size="20"
            color="blue lighten-5"
            class="mr-2"
          ></v-progress-circular
          >Loading...
        </span>
        <div class="mainMenu" v-else>
          <v-btn
            v-if="membersMenuItem"
            :key="membersMenuItem.title"
            :to="membersMenuItem.to"
            link
            plain
            class="menuItem"
            >{{ membersMenuItem.title }}</v-btn
          >
          <template v-for="menuItem in mainMenuItems">
            <v-menu
            class="menuItem"
            rounded="0"
            offset-y
            v-if="menuItem.items && menuItem.items.length"
            :key="menuItem.title"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" plain class="menuItem">
                  {{ menuItem.title }}
                </v-btn>
              </template>

              <v-list>
                <div v-for="item in menuItem.items" :key="item.title">
                  <v-list-group v-if="item.items && item.items.length" v-model="expandList" no-action @click.stop>
                    <template v-slot:activator>
                      <v-list-item-title> {{ item.title }} </v-list-item-title>
                    </template>
                    <v-list-item
                      v-for="subItem in item.items"
                      :key="subItem.title"
                      :to="subItem.to"
                      link
                      @click="expandList = false"
                      class="menuSubItem"
                    >
                      <v-list-item-title> {{ subItem.title }} </v-list-item-title>
                    </v-list-item>
                  </v-list-group>

                  <v-list-item v-else :to="item.to" link @click="expandList = false">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </div>
              </v-list>
            </v-menu>

            <v-btn
              v-else
              :to="menuItem.to"
              plain
              class="menuItem"
              :key="menuItem.title + '-singleMenuItem'"
            > 
              {{ menuItem.title }}
            </v-btn>
          </template>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-menu rounded="0" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" plain>
            <v-icon>mdi-account</v-icon>
            <span>{{ userName }}</span>
          </v-btn>
        </template>

        <v-list>
          <v-list-item link to="/Account">
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logOut">
            <v-list-item-title>
              <span>Log out</span><v-icon class="ml-1">mdi-logout</v-icon></v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  mounted: function () {
    // TODO: may currentPlanId be 0? If no then change this.userName to this.currentPlanId -
    // this is to check if user info is already set in store
    if (this.userName) this.getMenuItems();
  },
  data: () => ({
    drawer: true,
    isLoadingMenu: true,
    mainMenu: [],
    expandList: false,
  }),
  methods: {
    logOut() {
      this.$router.push({ name: 'Login', path: '/login' });
    },
    async getMenuItems() {
      const response = await this.$api.get(
        '/datadictionary/GetMenuItems?planId=' + this.currentPlanId
      );
      if (response.data) {
        this.processMenuItems(response.data);
      }
      this.isLoadingMenu = false;
    },
    processMenuItems(menuItems) {
      const menu = [];
      menuItems.forEach((x) => {
        const item = this.createMenuItem(x);
        menu.push(item);
      });
      this.$store.commit('setMenu', menu);
      this.mainMenu = menu;
      if (this.currentPlanId) this.createMenuItemsSet(menu);
    },
    createMenuItem(item) {
      const menuItem = {
        title: item.Name,
        to: this.getMenuToPath(item.FormName),
        isActive: false,
        items: [],
        permission: item.Permission,
        icon: item.MenuIcon
      };
      if (item.Children && item.Children.length > 0) {
        item.Children.forEach((x) => {
          const childrenMenuItem = this.createMenuItem(x);
          menuItem.items.push(childrenMenuItem);
        });
      }
      return menuItem;
    },
    createMenuItemsSet(menuItems) {
      const pathsSet = new Set();
      menuItems.forEach((m) => {
        if (m.to) pathsSet.add(m.to);
        if (m.items && m.items.length > 0) {
          m.items.forEach((t) => {
            if (t.to) pathsSet.add(t.to);
            if (t.items && t.items.length > 0) {
              t.items.forEach((x) => {
                if (x.to) pathsSet.add(x.to);
              });
            }
          });
        }
      });

      const availableRoutesList = [
        {
          path: '/SearchResult',
          name: 'SearchResult',
          props: true,
          component: () => import('../../views/Members/SearchResult.vue'),
        },
        {
          path: '/MemberDetails',
          name: 'BasicData',
          props: true,
          component: () => import('../../views/Members/MemberDetails.vue'),
        },
        {
          path: '/Beneficiaries',
          name: 'Beneficiaries',
          props: true,
          component: () => import('../../views/Members/Beneficiaries.vue'),
        },
        {
          path: '/Salary',
          name: 'Salary',
          props: true,
          component: () => import('../../views/Members/Salary.vue'),
        },

        {
          path: '/TransfersIn',
          name: 'TransfersIn',
          props: true,
          component: () => import('../../views/Members/TransfersIn.vue'),
        },
        {
          path: '/Service',
          name: 'Service',
          props: true,
          component: () => import('../../views/Members/Service.vue'),
        },
        {
          path: '/Profiles',
          name: 'Profiles',
          props: true,
          component: () => import('../../views/Members/Profiles.vue'),
        },
        {
          path: '/Transactions',
          name: 'Transactions',
          props: true,
          component: () => import('../../views/Members/Transactions.vue'),
        },
        {
          path: '/Switches',
          name: 'Switches',
          props: true,
          component: () => import('../../views/Members/Switches.vue'),
        },
        {
          path: '/MemberSummary',
          name: 'MemberSummary',
          props: true,
          component: () => import('../../views/Members/MemberSummary.vue'),
        },
        {
          path: '/MemberDocuments',
          name: 'MemberDocuments',
          component: () => import('../../views/Members/MemberDocuments.vue'),
        },
        {
          path: '/TaxProtection',
          name: 'TaxProtection',
          component: () => import('../../views/Members/TaxProtection.vue'),
        },
        {
          path: '/BenefitEvents',
          name: 'BenefitEvents',
          component: () => import('../../views/Members/BenefitEvents.vue'),
        },
        {
          path: '/MemberNotes',
          name: 'MemberNotes',
          component: () => import('../../views/Members/MemberNotes.vue'),
        },
        {
          path: '/ExitDeferred',
          name: 'ExitDeferred',
          component: () => import('../../views/Members/Leavers/ExitDeferred.vue'),
        },
        {
          path: '/TransferOut',
          name: 'TransferOut',
          component: () => import('../../views/Members/Leavers/TransferOut.vue'),
        },
        {
          path: '/Retirement',
          name: 'Retirement',
          component: () => import('../../views/Members/Leavers/Retirement.vue'),
        },
        {
          path: '/Death',
          name: 'Death',
          component: () => import('../../views/Members/Leavers/Death.vue'),
        },
        {
          path: '/ImportInvest',
          name: 'ImportInvest',
          component: () => import('../../views/Investments/ImportInvestmens.vue'),
        },
        {
          path: '/Investment',
          name: 'Invest',
          component: () => import('../../views/Investments/Invest.vue'),
        },
        {
          path: '/InvestSummary',
          name: 'InvestSummary',
          component: () => import('../../views/Investments/InvestSummary.vue'),
        },
        {
          path: '/Currency',
          name: 'Currency',
          component: () => import('../../views/Investments/Currency.vue'),
        },
        {
          path: '/PayrollImport',
          name: 'PayrollImport',
          component: () => import('../../views/Investments/PayrollImport.vue'),
        },
        {
          path: '/InvestmentProcess',
          name: 'InvestmentProcess',
          component: () => import('../../views/Investments/InvestmentProcess.vue'),
        },
        {
          path: '/InvestmentReports',
          name: 'InvestmentReports',
          component: () => import('../../views/Investments/InvestmentReports.vue'),
        },
        {
          path: '/importtest',
          name: 'ImportTest',
          component: () => import('../../views/Tester.vue'),
        },
        {
          path: '/Trustees',
          name: 'Trustees',
          component: () => import('../../views/Investments/Trustees.vue'),
        },
        {
          path: '/AddressBook',
          name: 'AddressBook',
          props: false,
          component: () => import('../../views/Rules/AddressBook.vue'),
        },
        {
          path: '/Clients',
          name: 'Clients',
          props: false,
          component: () => import('../../views/Rules/Clients.vue'),
        },
        {
          path: '/Picklists',
          name: 'Picklists',
          props: false,
          component: () => import('../../views/Rules/PicklistEditor.vue'),
        },
        {
          path: '/ImportDefinitions',
          name: 'ImportDefinitions',
          props: false,
          component: () => import('../../views/Rules/ImportDefinitions.vue'),
        },
        {
          path: '/Plans',
          name: 'Plans',
          props: false,
          component: () => import('../../views/Rules/Plans.vue'),
        },
        {
          path: '/Groups',
          name: 'Groups',
          props: false,
          component: () => import('../../views/Rules/Groups.vue'),
        },
        {
          path: '/Managers',
          name: 'Managers',
          props: false,
          component: () => import('../../views/Rules/Managers.vue'),
        },
        {
          path: '/Funds',
          name: 'Funds',
          props: false,
          component: () => import('../../views/Rules/Funds.vue'),
        },
        {
          path: '/FundPrices',
          name: 'FundPrices',
          props: false,
          component: () => import('../../views/Rules/FundPrices.vue'),
        },
        {
          path: '/FormBuilder',
          name: 'FormBuilder',
          props: false,
          component: () => import('../../views/Rules/FormBuilder.vue'),
        },
        {
          path: '/Forms',
          name: 'Forms',
          props: false,
          component: () => import('../../views/Rules/Forms.vue'),
        },
        {
          path: '/GridEditor',
          name: 'GridEditor',
          props: false,
          component: () => import('../../views/Rules/GridEditor.vue'),
        },
        {
          path: '/ReportsList',
          name: 'ReportsList',
          props: false,
          component: () => import('../../views/Reports/ReportsList.vue'),
        },
        {
          path: '/ReportWriter',
          name: 'ReportWriter',
          props: false,
          component: () => import('../../views/Reports/ReportWriter.vue'),
        },
        {
          path: '/RunReport',
          name: 'RunReport',
          props: false,
          component: () => import('../../views/Reports/RunReport.vue'),
        },
        {
          path: '/Letters',
          name: 'Letters',
          props: false,
          component: () => import('../../views/Reports/Letters.vue'),
        },
        {
          path: '/Lifestyle',
          name: 'Lifestyle',
          props: false,
          component: () => import('../../views/Rules/Lifestyle.vue'),
        },
        {
          path: '/InvestMatrix',
          name: 'InvestMatrix',
          props: false,
          component: () => import('../../views/Rules/InvestMatrix.vue'),
        },
        {
          path: '/InvestMatrix2',
          name: 'InvestMatrix2',
          props: false,
          component: () => import('../../views/Rules/InvestMatrix2.vue'),
        },
        {
          path: '/Charges',
          name: 'Charges',
          props: false,
          component: () => import('../../views/Rules/Charges.vue'),
        },
        {
          path: '/Calculations',
          name: 'Calculations',
          props: false,
          component: () => import('../../views/Rules/Calculations.vue'),
        },
        {
          path: '/Lookups',
          name: 'Lookups',
          props: false,
          component: () => import('../../views/Rules/Lookups.vue'),
        },
        {
          path: '/Users',
          name: 'Users',
          props: false,
          component: () => import('../../views/Security/Users.vue'),
        },
        {
          path: '/Roles',
          name: 'Roles',
          props: false,
          component: () => import('../../views/Security/Roles.vue'),
        },
        {
          path: '/AuditLog',
          name: 'Audit log',
          props: false,
          component: () => import('../../views/Security/AuditLog.vue'),
        },
        {
          path: '/AuditData',
          name: 'Audit Data',
          props: false,
          component: () => import('../../views/Security/AuditData.vue'),
        },
        {
          path: '/MemberAudit',
          name: 'Member Audit',
          props: false,
          component: () => import('../../views/Security/MemberAudit.vue'),
        },
        {
          path: '/About',
          name: 'About',
          component: () => import('../../views/Help/Help.vue'),
        },
        {
          path: '/Help',
          name: 'Help',
          component: () => import('../../views/Help/Help.vue'),
        },
        {
          path: '*',
          name: 'NotFound',
          component: () => import('../../views/NotFound.vue'),
        },
      ];

      Array.from(pathsSet).forEach((p) => {
        const foundRoute = availableRoutesList.find((r) => r.path === p);
        if (foundRoute) {
          const hasRoute = this.$router.getRoutes().some(r => r.name == foundRoute.name);
          if (!hasRoute){
            this.$router.addRoute(foundRoute);
          }
        }
      });

      if (!this.$router.getRoutes().find(r => r.name == "NotFound")){
        this.$router.addRoute({
        path: '*',
        name: 'NotFound',
        props: true,
        component: () => import('../../views/NotFound.vue'),
      });
      }

      
    },
    getMenuToPath(formName) {
      switch (formName) {
        case 'Members':
          return '/';
        case 'MemberSearch':
          return '/';
        case 'BasicData':
          return '/MemberDetails';
        case 'Beneficiaries':
          return '/Beneficiaries';
        case 'TransfersIn':
          return '/TransfersIn';
        case 'Service':
          return '/Service';
        case 'Salary':
          return '/Salary';
        case 'Investments':
          return '/ImportInvest';
        case 'ImportInvest':
          return '/ImportInvest';
        case 'Invest':
          return '/Investment';
        case 'InvestSummary':
          return '/InvestSummary';
        case 'PayrollImport':
          return '/PayrollImport';
        case 'InvestmentProcess':
          return '/InvestmentProcess';
          case 'InvestmentReports':
          return '/InvestmentReports';
        case 'Trustees':
          return '/Trustees';
        case 'Currency':
          return '/Currency';
        case 'ExitDeferred':
          return '/ExitDeferred';
        case 'TransferOut':
          return '/TransferOut';
        case 'Retirement':
          return '/Retirement';
        case 'Death':
          return '/Death';
        case 'Profiles':
          return '/Profiles';
        case 'Transactions':
          return '/Transactions';
        case 'Switches':
          return '/Switches';
        case 'MemberSummary':
          return '/MemberSummary';
        case 'MemberDocuments':
          return '/MemberDocuments';
        case 'TaxProtection':
          return '/TaxProtection';
        case 'BenefitEvents':
          return '/BenefitEvents';
        case 'MemberNotes':
          return '/MemberNotes';
        case 'Rules':
          return '/Clients';
        case 'AddressBook':
          return '/AddressBook';
        case 'Clients':
          return '/Clients';
        case 'Plans':
          return '/Plans';
        case 'Groups':
          return '/Groups';
        case 'Managers':
          return '/Managers';
        case 'FormBuilder':
          return '/FormBuilder';
        case 'Forms':
          return '/Forms';
        case 'GridEditor':
          return '/GridEditor';
        case 'Funds':
          return '/Funds';
        case 'ImportDefinitions':
          return '/ImportDefinitions';
        case 'Picklists':
          return '/Picklists';
        case 'ReportsList':
          return '/ReportsList';
        case 'Security':
          return '/Users';
        case 'Users':
          return '/Users';
        case 'Lifestyle':
          return '/Lifestyle';
        case 'InvestMatrix':
          return '/InvestMatrix';
        case 'Charges':
          return '/Charges';
        case 'Calculations':
          return '/Calculations';
        case 'Lookups':
          return '/Lookups';
        case 'Roles':
          return '/Roles';
        case 'AuditLog':
          return '/AuditLog';
        case 'AuditData':
          return '/AuditData';
        case 'MemberAudit':
          return '/MemberAudit';
        case 'Help':
          return '/Help';
        case 'About':
          return '/About';
        case 'Letters':
          return '/Letters';
        case 'FundPrices':
          return '/FundPrices';  
        case 'FormEditors':
          return '/Forms';
        default:
          return null;
      }
    },
  },
  computed: {
    userName() {
      const userInfo = this.$store.getters.userInfo;
      if (userInfo) return userInfo.UserName;

      return '';
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    membersMenuItem() {
      if (this.mainMenu && this.mainMenu.length > 0) {
        const memberMenuItem = this.mainMenu.find((x) => {
          return x.title == 'Members';
        });
        return memberMenuItem;
      }

      return null;
    },
    mainMenuItems() {
      return this.mainMenu && this.mainMenu.length > 0
        ? this.mainMenu.filter((x) => {
            return x.title != 'Members';
          })
        : [];
    },
  },
  watch: {
    currentPlanId: function () {
      if (this.userName) this.getMenuItems();
    },
  },
};
</script>

<style lang="scss">
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;
  }
}

.auroraTitle {
  font-family: Montserrat;
  font-size: 24px;
  margin-top: -5px;
  margin-right: 20px;
}

.mainMenu {
  font-family: Roboto;

  .menuItem {
    margin-right: 5px;
  }
}

.menuSubItem {
  padding-left: 45px !important;
}
</style>
